import React from 'react';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import HoverTooltip from '@Components/HoverTooltip';
import { TooltipConstants } from '@Components/Tooltip';
import Button from '@Components/Button';

import './PreferencesTooltip.scss';

function PreferencesTooltip({ content, label, name }) {
  return (
    <div className="preferences-tooltip">
      <div className="preferences-tooltip__label">{label}</div>
      <HoverTooltip
        id={TooltipConstants.ids.GlobalHover}
        tooltip={ReactDOMServer.renderToString(
          <ul className="info-tooltip-content-list">
            {content.map((contentItem, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={`preferences-tooltip-${name}-${index}`} className="info-tooltip-content-list-item bullet-dot">
                {contentItem}
              </li>
            ))}
          </ul>
        )}>
        <Button
          buttonConfig={{
            type: 'link',
            className: 'info-tooltip',
            size: 'lg',
            aTag: true,
            noBorder: true,
            iconOnly: true,
            e2eName: `${name}-tooltip`,
          }}
          iconConfig={{
            name: 'information',
            size: 'sm',
            noBorder: true,
          }}
        />
      </HoverTooltip>
      <div />
    </div>
  );
}

PreferencesTooltip.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  content: PropTypes.arrayOf(PropTypes.node),
};

export default PreferencesTooltip;
